import { render, staticRenderFns } from "./ProductGroupEditCard.vue?vue&type=template&id=d1392af0&scoped=true"
import script from "./ProductGroupEditCard.vue?vue&type=script&lang=ts"
export * from "./ProductGroupEditCard.vue?vue&type=script&lang=ts"
import style0 from "./ProductGroupEditCard.vue?vue&type=style&index=0&id=d1392af0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1392af0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1392af0')) {
      api.createRecord('d1392af0', component.options)
    } else {
      api.reload('d1392af0', component.options)
    }
    module.hot.accept("./ProductGroupEditCard.vue?vue&type=template&id=d1392af0&scoped=true", function () {
      api.rerender('d1392af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-group/ProductGroupEditCard.vue"
export default component.exports